import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextPurchase } from '../Purchase';
import { User } from '../../../../models/user.model';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Contact }  from '../../../../models/contact.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { Service } from '../../../../models/service.model';
import { Product } from '../../../../models/product.model';
import { StorageCenter } from '../../../../models/storage.center.model';

export interface ProviderOrderPageProps {};

type ContexType = {
  asideMinimize: string,
  setAsideMinimize: Dispatch<SetStateAction<string>>,
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  storageCentersForCompany: StorageCenter[] | null,
  loadSettingsForCompany: Function,
  loadContactsForCompany: Function,
  loadStorageCentersForCompany: Function
};

const ProviderOrderPage: React.FunctionComponent<ProviderOrderPageProps> = props => {
  const {asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, loadSettingsForCompany, loadContactsForCompany, loadStorageCentersForCompany} = UseOutletContextPurchase()

  return (
    <Outlet context={{asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, loadSettingsForCompany, loadContactsForCompany, loadStorageCentersForCompany}}></Outlet>
  );
}

export function UseOutletContextProviderOrder() {
  return useOutletContext<ContexType>()
};

export default ProviderOrderPage;
